import { qaBackendApiInstance } from "@src/config/config"

const MAX_RETRIES = 3;
const TIMEOUT_ERROR_CODE = 524;

export async function bulkAudioGeneration(voiOverData: any) {
  let retries = 0;
  
  while (retries < MAX_RETRIES) {
    try {
      const postBody = {
        data: voiOverData
      }
      const response = await qaBackendApiInstance.post(
        `video/gen-video-captions`,
        postBody
      )
      if (response.status === 200) {
        return response.data
      }
    } catch (error: any) {
        console.log(error)
      if (error.code === 'ERR_NETWORK' && retries < MAX_RETRIES - 1) {
        retries++;
        continue;
      }
      console.error(error)
      return undefined
    }
  }
  return undefined;
}